module.exports = {"410184001":"新建路街道","410184002":"新华路街道","410184003":"新烟街道","410184101":"新村镇","410184102":"辛店镇","410184103":"观音寺镇","410184104":"梨河镇","410184105":"和庄镇","410184106":"薛店镇","410184107":"孟庄镇","410184108":"郭店镇","410184109":"龙湖镇","410184200":"城关乡","410184402":"具茨山国家级森林公园管理委员会","410184403":"中心城区新区建设管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410184.json
// module id = 1526
// module chunks = 0